import React, { useState } from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';
import LoadingIndicator from './LoadingIndicator';

const FullPageLoadingIndicator = (props) => {
    const { className, subtext = null } = props;
    const [isVisible, setIsVisible] = useState(false);
    setTimeout(() => setIsVisible(true), 200);
    return (
        <div className={cns('full-page-loading-spinner', className)}>
            <div className={'indicator-container'}>
                {isVisible ? <LoadingIndicator /> : null}
                {subtext && <span classNam={'loading-subtext'}>{subtext}</span>}
            </div>
        </div>
    );
};

FullPageLoadingIndicator.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subtext: PropTypes.string
};

export default FullPageLoadingIndicator;
